<p>
  <button app-add-button [label]="'events.settings.items.ceu-edit.add-ceu-label' | translate" (click)="handleAddClick()"></button>
</p>

<table class="wl-credit-types-grid" [hidden]="!eventItemCreditTypes.length">
  <thead>
    <tr>
      <th></th>
      <th>
        {{ 'events.settings.items.ceu-edit.credit-type-column-header' | translate | titlecase }}
      </th>
      <th>
        {{ 'events.settings.items.ceu-edit.ceu-credits-column-header' | translate | titlecase }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let eventItemCreditType of eventItemCreditTypes"
      [ngClass]="{ 'wl-pending-delete': eventItemCreditType.ObjectState == _objectStateEnum.Deleted }"
    >
      <td>
        <button
          pButton
          type="button"
          class="atlas-btn atlas-btn-danger btn-sm"
          icon="pi pi-trash"
          (click)="handleRemoveClick(eventItemCreditType)"
          [hidden]="eventItemCreditType.ObjectState == _objectStateEnum.Deleted"
        ></button>

        <button
          pButton
          type="button"
          class="atlas-btn atlas-btn-default btn-sm"
          icon="pi pi-refresh"
          (click)="handleUnRemoveClick(eventItemCreditType)"
          [hidden]="eventItemCreditType.ObjectState != _objectStateEnum.Deleted"
          [pTooltip]="'common.undelete' | translate | titlecase"
          tooltipPosition="top"
        ></button>
      </td>
      <td>
        <wl-events-ceu-type-dropdown
          [(ngModel)]="eventItemCreditType.CreditTypeId"
          inputCssClass="form-control wl-credit-type-input"
          [required]="true"
          (onCreditTypeChange)="handleCreditTypeChange(eventItemCreditType, $event)"
          [disabled]="eventItemCreditType.ObjectState == _objectStateEnum.Deleted"
        ></wl-events-ceu-type-dropdown>
      </td>
      <td>
        <input
          [(ngModel)]="eventItemCreditType.Credits"
          class="form-control wl-credits-input"
          type="number"
          min="0"
          [disabled]="eventItemCreditType.ObjectState == _objectStateEnum.Deleted"
        />
      </td>
    </tr>
  </tbody>
</table>
